export function deleteParentContainer(el) {
  const nodeHasNonWhitespace = RegExp(/\S/);
  //including el
  const allSiblings = Array.from(el.parentElement.childNodes);
  const actualSiblings = allSiblings.filter((sibling) => {
    return nodeHasNonWhitespace.test(sibling.textContent);
  });

  const hasSiblings = actualSiblings.length > 1;

  //if the parent is a container and no siblings recurse
  if (el.parentElement.classList.contains("container") && !hasSiblings) {
    deleteParentContainer(el.parentElement);
  }
  //otherwise remove the element
  else {
    el.parentElement.removeChild(el);
  }
}

export default function removeNodes(parentElement, nodeList) {
  nodeList.forEach((component) => {
    parentElement
      .querySelectorAll(component)
      .forEach((element) => deleteParentContainer(element));
  });
}
